import styled from 'styled-components';
import { Colors } from '~/constants';


export const ColumnHeader = styled.th`
  color: ${Colors.DARK_GREY};
  font-size: 14px;
  font-weight: normal;
  border-bottom: 1px solid ${Colors.BORDER_GREY};
`;

export const StyledCheckbox = styled.input`
  width: 20px;
  height: 20px;
  margin: 2px 12px 2px 0px;
  border: solid 2px var(--disabled-button-gray);
  float: left;
`;
